<template>
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :default-cancel="false"
    :title="$t('cos.create_bucket[0]')" :width="500" @close="closeDialog">
    <div>
      <ul class="cos-form__list">
        <li class="cos-form__item">
          <div>
            <p class="cos-form__label">{{$t("cos.bucket_name")}}</p>
            <div class="form-unit" :class="{'is-error': bucketFormatTag ==='error'}">
              <input class="tc-15-input-text xs" :placeholder="$t('cos.placeholder.bucket')" v-model.trim="bucketName"
                @keyup="checkBucketName" @input="checkBucketName" :style="$store.IsQCloudCos&&appId?'width:64%;':''" />
              <span v-if="appId" class="text" style="line-height:30px;">-{{appId}}</span>
              <qc-icon :type="bucketFormatTag" v-if="bucketFormatTag"></qc-icon>
              <div class="form-input-help">{{bucketFormatMsg}}</div>
            </div>
          </div>
        </li>

        <li class="cos-form__item" v-if="$store.showRegion">
          <p class="cos-form__label">{{$t("cos.region_name")}}</p>
          <div>
            <qc-autocomplete :placeholder="$t('cos.placeholder.region')" v-model.trim="region"
              trigger="focus" :options="regionList" style="width:362px"></qc-autocomplete>
          </div>
        </li>

        <li class="cos-form__item">
          <p class="cos-form__label">{{$t('cos.endpoint')}}</p>
          <p class="text-tile">{{bucketDomain}}</p>
        </li>

        <li class="cos-form__item">
          <p class="cos-form__label">{{$t('cos.acl')}}</p>
          <div>
            <!-- 调整中英文格式 -->
            <template v-if="$store.localeLanguage==='zh'">
              <label class="form-ctrl-label">
                <input type="radio" v-model="acl" class="tc-15-radio" value="private">
                {{$t("cos.acl_map.private")}}
              </label>
              <label class="form-ctrl-label">
                <input type="radio" v-model="acl" class="tc-15-radio" value="public-read" />
                {{$t("cos.acl_map.public-read")}}
              </label>
              <label class="form-ctrl-label">
                <input type="radio" v-model="acl" class="tc-15-radio" value="public-read-write" />
                {{$t("cos.acl_map.public-read-write")}}
              </label>
            </template>
            <template v-else>
              <div class="mt-10">
                <label class="form-ctrl-label">
                  <input type="radio" v-model="acl" class="tc-15-radio" value="private" />
                  {{$t("cos.acl_map.private")}}
                </label>
              </div>
              <div class="mt-10">
                <label class="form-ctrl-label">
                  <input type="radio" v-model="acl" class="tc-15-radio" value="public-read" />
                  {{$t("cos.acl_map.public-read")}}
                </label>
              </div>
              <div class="mt-10">
                <label class="form-ctrl-label">
                  <input type="radio" v-model="acl" class="tc-15-radio" value="public-read-write" />
                  {{$t("cos.acl_map.public-read-write")}}
                </label>
              </div>
            </template>
          </div>
        </li>

        <!-- 存储桶标签 -->
        <li class="cos-form__item">
          <p class="cos-form__label">{{$t('cos.bucket_tag')}}</p>
          <div ref="createBucketTag" style="max-height: 120px; overflow-y: auto;">
            <div v-for="(tag, index) in tagList" :key="index" class="tag-item">
              <qc-autocomplete v-model="tag.Key" :placeholder="$t('cos.placeholder.tag_key')" trigger="focus">
                <qc-option v-for="(tagKey,index) in extantTagList" :key="index" :value="tagKey"></qc-option>
              </qc-autocomplete>
              <qc-input size="middle" v-model="tag.Value" :placeholder="$t('cos.placeholder.tag_value')"></qc-input>
              <qc-button type="icon" @click="addTagItem(index)">
                <qc-icon type="add"></qc-icon>
              </qc-button>
              <qc-button type="icon" v-show="index !== 0" @click="deleteTagItem(index)">
                <qc-icon type="minus"></qc-icon>
              </qc-button>
            </div>
          </div>
        </li>

        <li class="cos-form__item" v-if="allowMaz">
          <p class="cos-form__label">
            {{$t('cos.MAZ_configuration')}}
            <qc-bubble class="ml-5" type="default" :append-to-body="false" placement="right">
              <qc-icon type="plaint"></qc-icon>
              <template slot="popup">{{$t('cos.tips.MAZ_configuration')}}</template>
            </qc-bubble>
          </p>
          <div class="form-unit">
            <qc-switch v-model="openMAZ"></qc-switch>
            <!-- <span class="form-input-help">开启多AZ特性后，提供同地域多个数据中心的容灾</span> -->
          </div>
        </li>
      </ul>
    </div>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="createConfirm" :title="$t('core.ok')" :disabled="!allowSubmit">
            {{$t('core.ok')}}
          </qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>
  </qc-dialog>
</template>

<script>
import { tips } from '@/scripts/tools/utils';
import cos from '@/scripts/helper/cos';
import { regions } from '@/scripts/tools/config';
import dao from '@/scripts/helper/dao';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    bucketList: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      bucketName: '',
      region: '',
      acl: 'private',
      openMAZ: false,

      bucketFormatTag: 'success',
      bucketFormatMsg: '',
      regionList: [],
      V4RegionMap: {},
      allowMazRegions: [],
      tagList: [{}],
      extantTagList: [],
    };
  },
  computed: {
    innerShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
    appId() {
      return this.$store.userInfo.AppId || '';
    },
    bucketDomain() {
      let bucket = this.bucketName || '<Bucket>';
      const region = this.region || '<Region>';
      if (this.appId) bucket += `-${this.appId}`;
      return `${bucket}.cos.${region}.myqcloud.com`;
    },
    allowSubmit() {
      if (this.$store.showRegion) {
        return (
          this.bucketName && this.bucketFormatTag === 'success' && this.region
        );
      }
      return this.bucketName && this.bucketFormatTag === 'success';
    },
    allowMaz() {
      const { region } = this;
      const { showRegion, IsQCloudCos } = this.$store;

      let isInMAZRegions = false;
      // 若在多 AZ 地域列表中 || 远端列表未获取到
      if (this.allowMazRegions.includes(region) || !this.regionList.length) {
        isInMAZRegions = true;
      }
      // TODO: 等到 js SDK 支持多 AZ，把 0 删除
      return (
        showRegion && IsQCloudCos && isInMAZRegions
      );
    },
    tagListWithoutEmpty() {
      return this.tagList.filter(tag => tag.Key && tag.Value);
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.initData();
        this.getBucketTagList();
      }
    },
  },
  mounted() {
    this.getRemoteConfig();
  },
  methods: {
    initData() {
      this.bucketName = '';
      this.region = '';
      this.acl = 'private';
      this.openMAZ = false;
      this.tagList = [{}];
      this.bucketFormatTag = 'success';

      const defaultMsg = 'bucket_name_format_simple';
      this.bucketFormatMsg = this.$t(`cos.validate.${defaultMsg}`);
    },
    getRemoteConfig() {
      const language = this.$store.localeLanguage;
      const regionList = regions.filter(v => !v.hidden) || [];
      this.regionList = regionList.map(item => {
        this.V4RegionMap[item.region] = item.region_v4;
        !item.disable_maz && this.allowMazRegions.push(item.region);

        let label = '';
        if (language === 'zh') {
          const labelLan = `label_${language}`;
          label = `(${item[labelLan]})`;
        }
        return {
          label: item.region + label,
          value: item.region,
        };
      });
    },
    checkBucketName() {
      if (!this.bucketName) return;

      const { bucketName } = this;
      this.bucketFormatTag = 'success';
      if (!bucketName.length) {
        this.bucketFormatMsg = this.$t('cos.validate.empty_input_content');
        this.bucketFormatTag = 'error';
      } else if (bucketName.length > 50) {
        this.bucketFormatMsg = this.$t('cos.validate.bucket_name_length');
        this.bucketFormatTag = 'error';
      } else if (!/^[a-z0-9\-]{1,50}$/g.test(bucketName)) {
        this.bucketFormatMsg = this.$t('cos.validate.bucket_name_char');
        this.bucketFormatTag = 'error';
      } else if (bucketName[0] === '-') {
        this.bucketFormatMsg = this.$t(
          'cos.validate.bucket_name_end_with[0]',
        );
        this.bucketFormatTag = 'error';
      } else if (bucketName[bucketName.length - 1] === '-') {
        this.bucketFormatMsg = this.$t(
          'cos.validate.bucket_name_end_with[1]',
        );
        this.bucketFormatTag = 'error';
      }
      if (this.bucketFormatTag === 'error') return;

      const defaultMsg = 'bucket_name_format_simple';
      this.bucketFormatMsg = this.$t(`cos.validate.${defaultMsg}`);
      this.bucketFormatTag = 'success';
    },
    createBucket() {
      tips.loading(
        this.$t('core.state_map.doing[0]', {
          action: this.$t('cos.create_bucket[0]'),
        }),
      );
      const { bucketName, region, acl } = this;
      let bucket = bucketName;
      if (this.appId) bucket += `-${this.appId}`;

      // 判断是否已存在存储桶列表里
      const exist = this.bucketList.some(
        v => v.Bucket === bucket && this.Region === region,
      );
      if (exist) {
        tips.error(this.$t('error.BucketAlreadyExists'));
        return;
      }

      const params = { Bucket: bucket, Region: region, ACL: acl };
      if (this.openMAZ) {
        params.BucketAZConfig = 'MAZ';
      }
      cos.putBucket(params, err => {
        if (err) {
          tips.closeTips();
          if (
            err.error
            && ['BucketAlreadyExists', 'BucketAlreadyOwnedByYou'].includes(
              err.error.Code,
            )
          ) {
            tips.error(this.$t('error.BucketAlreadyExists'));
          } else if (
            ['AccessDenied'].includes(err.error.Code)
            || err.statusCode === '403'
          ) {
            tips.error(this.$t('error.no_permissions_to_create_bucket'));
          } else {
            tips.error(window.lang.err('error.failed_to_create_bucket', err));
          }
          return;
        }
        // 创建存储桶成功，但只刷新不提示
        this.$emit('submit');
        // 随后，将执行下列后续操作
        const promiseList = [
          this.tagListWithoutEmpty.length !== 0
            ? this.putTagging(params)
            : null,
          acl === 'private'
          || !this.$store.IsQCloudCos
          || !this.$store.SyncV4BucketAcl
            ? null
            : this.handleSetV4BucketAcl(params),
        ];
        Promise.all(promiseList).then(() => {
          tips.closeTips();
          tips.success(
            this.$t('core.success', { msg: this.$t('cos.create_bucket[0]') }),
          );
        });
      });
    },
    createConfirm() {
      if (this.tagListWithoutEmpty.length !== 0) {
        const errCode = this.getTagErrorCode();
        if (errCode) {
          tips.error(this.$t(`cos.validate.${errCode}`));
          return;
        }
      }
      this.createBucket();

      this.closeDialog();
    },
    closeDialog() {
      this.innerShow = false;
      this.$emit('cancel');
    },
    // 验证标签
    getTagErrorCode() {
      let code = '';
      this.tagListWithoutEmpty.forEach((tag, index) => {
        const { Key, Value } = tag;
        if (!Key || !Value) {
          //   不能为空
          code = 'enter_a_full_tag_key_and_tag_value';
          return code;
        }
        if (/^(项目|project|qcs:)/.test(Key.toLowerCase())) {
          //   键不能以 项目|project|qcs: 开头
          code = 'tag_keys_cannot_begin_with';
          return code;
        }
        if (Key.length > 127) {
          //   键不能长于127
          code = 'tag_key_length_cannot_be_greater_than_127_characters';
          return code;
        }
        if (Value.length > 255) {
          //   值不能长于255
          code = 'tag_value_length_cannot_be_greater_than_255_characters';
          return code;
        }

        for (let j = 0; j < this.tagListWithoutEmpty.length; j++) {
          if (this.tagListWithoutEmpty[j].Key === Key && j !== index) {
            code = 'repetitive_tag_keys_are_not_allowed';
            return code;
          }
        }
        return code;
      });

      return code;
    },
    // 设置存储桶标签操作
    putTagging(param) {
      const { Bucket, Region } = param;
      const params = {
        Bucket,
        Region,
        Tagging: { Tags: this.tagListWithoutEmpty },
      };
      return new Promise(resolve => {
        cos.putBucketTagging(params, () => {
          resolve();
        });
      });
    },
    // 双写权限
    // v4默认是私有，所以私有时不用
    handleSetV4BucketAcl(param) {
      const V4Region = this.V4RegionMap[param.Region];
      const { Bucket, Region, ACL } = param;
      const params = {
        Bucket,
        Region,
        V4Region,
        ACL,
      };
      return new Promise(resolve => {
        dao.putV4BucketAcl(params).then(() => {
          resolve();
        }).catch(() => {
          resolve();
        });
      });
    },
    // 指定位置增加一个标签项
    addTagItem(index) {
      if (this.tagList.length >= 10) {
        tips.error(window.lang.t('error.up_to_10_tags_are_allowed'));
        return;
      }
      this.tagList.splice(index + 1, 0, {});
    },
    // 指定删除一个标签项
    deleteTagItem(index) {
      this.tagList.splice(index, 1);
    },
    // 获取存储桶标签列表
    async getBucketTagList() {
      try {
        const data = await dao.getBucketTagList({ isFull: true });
        const _data = data.Rows || data.Tags;
        if (!_data) {
          this.extantTagList = [];
          return;
        }
        // 全量标签列表存在重复情况，需要去重
        this.extantTagList = [...new Set(_data.map(v => v.TagKey))];
      } catch (error) {
        this.extantTagList = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-item {
  margin-bottom: 2px;
  button {
    font-size: 1em !important;
  }
}
</style>
